import './Banner.css'

function Banner(){

    // JSX
    return (

        <header className="banner"> 
            <img src="/imagens/banner.png" alt="Banner Magalu"></img>
        </header> 
    );
};

export default Banner;